import React, { useState, useEffect, useRef } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Toast, ToastBody, CloseButton } from "reactstrap"
import { checkTotalItemMessageToast, removeTotalItemMessageToast, openEmailComposeQuietanza } from '../../store/app/ws/WsSlice';
import ToastContent from './ToastContent';
import { closePopupFattura, invalidateLavorabiliCompleti, markTicketListsDirty } from '../../store/app/ticket/TicketSlice';

const ToastContainer = () => {
  const dispatch = useDispatch();
  //const [messageHistory, setMessageHistory] = useState([]);

  const WS_URL = `${process.env.REACT_APP_WS_SINISTRI_URL}`;  
  const [socketUrl] = useState(WS_URL);
  // CSP-3429: la prima apertura e' l'avvio normale; dalla seconda in poi siamo
  // su una riconnessione, e i messaggi emessi dal server mentre la socket era
  // chiusa sono persi (non c'e' replay lato server).
  const primaConnessione = useRef(true);
 // const didUnmount = useRef(false);
  const { lastMessage, readyState } = useWebSocket(socketUrl, {   
      onOpen: () => {
        if (primaConnessione.current) {
          primaConnessione.current = false;
          return;
        }
        // Riconnessione: non sappiamo che cosa e' successo mentre eravamo
        // scollegati, quindi segniamo le liste da rileggere invece di fidarci
        // dei soli messaggi ricevuti. Il refetch avviene alla prossima apertura
        // di un tab (CSP-3428), non subito: qui potremmo essere dentro il
        // dettaglio di un task.
        dispatch(markTicketListsDirty());
        dispatch(invalidateLavorabiliCompleti());
      },
      onClose: (closeEvent) =>  {
        console.log(`${closeEvent} - on close reconnecting`);
        return true;
      },
      // eslint-disable-next-line no-unused-vars
      shouldReconnect: (closeEvent) =>  {return true},
      share : true,
      retryOnError : true,
      reconnectAttempts: 100000,
      reconnectInterval: 10,
        //Math.min(Math.pow(2, attemptNumber) * 1000, 10000),
      // CSP-3429: qui c'era un blocco heartbeat { message, returnMessage,
      // timeout: 10, interval: 10 }. Era codice morto: package.json fissa
      // react-use-websocket ^3.0.0 e l'unica 3.x pubblicata e' la 3.0.0, la cui
      // interfaccia Options non ha il campo heartbeat (arriva con la linea
      // 4.x). Nessun ping e' mai stato inviato. I due valori erano comunque
      // sbagliati: timeout e interval sono in millisecondi, quindi 10 avrebbe
      // significato "chiudi se il pong non torna entro 10 ms", non il minuto e
      // i 25 secondi dei commenti.
      // Il keep-alive vero e proprio (ping applicativo o upgrade alla 4.x)
      // richiede di sapere come risponde l'endpoint a un messaggio non
      // instradato, che sta fuori da questo repo: resta aperto sul ticket.
      // Intanto la riconnessione non passa piu' inosservata, vedi onOpen.
  });

  const connectionStatus = {
    [ReadyState.CONNECTING]: 'Connecting',
    [ReadyState.OPEN]: 'Open',
    [ReadyState.CLOSING]: 'Closing',
    [ReadyState.CLOSED]: 'Closed',
    [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  }[readyState];
  const handleRemoveTaskNavTab = (reqId) => {
    dispatch(removeTotalItemMessageToast(reqId)); //AddNavTaskReducer  
  }

  useEffect(() => {
    if (lastMessage !== null) {
      //setMessageHistory((prev) => prev.concat(lastMessage));
      //console.log(messageHistory);
      // CSP-3136 - evento server-initiated per aprire la bozza email quietanza.
      // Gestito a parte (non ha un requestId in attesa): il dispatch popola lo stato
      // redux; sarà il componente che ha il task aperto (match su taskId) ad aprire EmailCompose.
      let parsedWsData = null;
      try { parsedWsData = JSON.parse(lastMessage.data); } catch (e) { parsedWsData = null; }
      if (parsedWsData?.eventType === 'OPEN_EMAIL_COMPOSE_QUIETANZA') {
        dispatch(openEmailComposeQuietanza({
          pdfAllegatoId: parsedWsData.pdfAllegatoId,
          taskId: parsedWsData.taskId,
          sinistroId: parsedWsData.sinistroId
        }));
        return;
      }
      //proviamo ad alleggerire l'oggetto per non far sudare redux
      const lastMessageLight = `{"requestId":"${JSON.parse(lastMessage.data)?.requestId}", "operation":{"status":"${JSON.parse(lastMessage.data)?.operation?.status}", "statusCode": "${JSON.parse(lastMessage.data)?.operation?.statusCode}"}}`;
      const dataLastMessageLight = { "data" : lastMessageLight}
      dispatch(checkTotalItemMessageToast(dataLastMessageLight));
    } else
    {console.log('readyState');
      console.log(connectionStatus);
    console.log(readyState);}
  }, [lastMessage,readyState]);

  // useEffect(() => {
  //   return () => {
  //     didUnmount.current = true;
  //   };
  // }, []);

  const totalRequestMessage = useSelector((state) => state.wsReducer.itemMessages);
  //console.log("totalRequestMessage",totalRequestMessage);
  const totalRequestMessageToast = useSelector((state) => state.wsReducer.itemMessagesToast);      
  const popupFattura = useSelector((state) => state.ticketReducer.popupFattura);

  const isPopupFatturaError = popupFattura?.type === 'error';

  useEffect(() => {
    if (!popupFattura?.open) return undefined;

    // Gli errori restano visibili più a lungo per dare tempo di leggere il messaggio.
    const timeoutId = setTimeout(() => {
      dispatch(closePopupFattura());
    }, isPopupFatturaError ? 8000 : 2500);

    return () => clearTimeout(timeoutId);
  }, [dispatch, popupFattura?.message, popupFattura?.open, isPopupFatturaError]);

  const popupFatturaMessage = popupFattura?.message || 'Salvataggio fattura completato con successo.';

  return (    
    <div className="toast_container position-fixed bottom-0 start-0 ms-4 mb-4" style={{ zIndex: 10000 }}>
    
        {[...new Map(totalRequestMessage.map((m) => [JSON.parse(m).requestId, m])).values()].map((message) => {
           const { requestId } = JSON.parse(message);
           const isVisible = totalRequestMessageToast.findIndex((messageToast) => messageToast.requestId === requestId) !== -1;
           if (!isVisible) return null;
           return (
             <Toast className="d-flex bg-dark text-bg-dark align-items-top border-0 mb-2 p-2 shadow-lg" key={requestId}>
               <ToastBody>
                 <ToastContent message={message} />
               </ToastBody>
               <CloseButton  variant="white" className="mt-2 ms-auto me-2" aria-label="Chiudi" onClick={() => handleRemoveTaskNavTab(requestId)} />
             </Toast>
           );
        })}
        {popupFattura?.open ? (
          <Toast className={`d-flex align-items-top border-0 mb-2 p-2 shadow-lg ${isPopupFatturaError ? 'bg-danger text-bg-danger' : 'bg-dark text-bg-dark'}`} key="fattura-toast">
            <ToastBody>
              <h5 className="fw-bold mb-2">{isPopupFatturaError ? 'Errore salvataggio fattura' : 'Esito salvataggio fattura'}</h5>
              <p className="mb-0">{popupFatturaMessage}</p>
            </ToastBody>
            <CloseButton variant="white" className="mt-2 ms-auto me-2" aria-label="Chiudi" onClick={() => dispatch(closePopupFattura())} />
          </Toast>
        ) : null}
          {/* <span>The WebSocket is currently <b>{(readyState===1) ? 'opened':'closed'}</b></span>  */}
    </div>
  )
}

export default ToastContainer;
